import { IconProps } from "types/StylesTypes";

export const PlusIcon: React.FC<IconProps> = ({
  color = "currentColor",
  size = 24,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1"
        y="1"
        width="22"
        height="22"
        rx="5"
        stroke="#1C2226"
        strokeWidth="2"
      />
      <g clipPath="url(#clip0_413_12772)">
        <path
          d="M12.001 18.5455V5.45459"
          stroke="#1C2226"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.546 12H5.45508"
          stroke="#1C2226"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_413_12772">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(4 4)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
